// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_AplicarCoresOperadoresResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /agenda/aplicar_cores_operadores
 *
 * Action endpoint — applies operator colors received from the frontend.
 * `dados` is always null. Operation success is signaled by the envelope's
 * `success` flag.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Agenda_AplicarCoresOperadoresResponseDados = null;

export type Agenda_AplicarCoresOperadoresResponse = ApiResponse<Agenda_AplicarCoresOperadoresResponseDados>;

registerResponseContract('Agenda_AplicarCoresOperadoresResponse', {})
